// extracted by mini-css-extract-plugin
module.exports = {"divider":"OwnersDropdown_divider__2xx_U","footer":"OwnersDropdown_footer__6ahLw","addBtn":"OwnersDropdown_addBtn__awKnw"};